/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { UserEntity } from '@axiom/domain';
/**
 * Response projection of the User entity. Extends UserEntity
 * (inherits `static key = 'User'`), so this projection and the full
 * User entity merge into the same normalized cache record.
 * dark-roast DTO: UserResponseDto
 * also used by updateUser
 */
export class CreateUsersResponseEntity extends UserEntity {
  override hasAcceptedTermsAndConditions: boolean | null = null;
}